module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Checkmark_selected_Light Blue.5ef36cc5.svg";